import { useState } from "react";
import { partyLinks } from "@/mocks/partes";
import PartyRoleBadge from "./PartyRoleBadge";

const linkStatusColors: Record<string, string> = {
  "Ativo": "bg-primary-100 text-primary-700",
  "Pendente": "bg-warning-100 text-warning-700",
  "Em revisão": "bg-warning-50 text-warning-600",
  "Encerrado": "bg-background-100 text-foreground-500",
  "Suspenso": "bg-danger-100 text-danger-700",
  "Substituído": "bg-background-200 text-foreground-400",
};

const projectNames = [...new Set(partyLinks.map((l) => l.projectName))];

export default function ProjectPartiesPanel() {
  const [expandedProject, setExpandedProject] = useState<string | null>(null);

  return (
    <div className="space-y-4">
      <h3 className="text-sm font-semibold text-foreground-900">Vínculos por Projeto</h3>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {projectNames.map((projectName) => {
          const links = partyLinks.filter((l) => l.projectName === projectName);
          const isExpanded = expandedProject === projectName;

          return (
            <div key={projectName} className="bg-white rounded-xl border border-background-200/70 overflow-hidden">
              <div className="p-4">
                <h4 className="text-sm font-semibold text-foreground-900 font-heading mb-2">{projectName}</h4>
                <div className="flex items-center gap-3 text-xs text-foreground-500 mb-3">
                  <span className="flex items-center gap-1">
                    <i className="ri-team-line w-3.5 h-3.5 flex items-center justify-center text-primary-500" />
                    <strong className="text-primary-600">{links.length}</strong> partes
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-check-line w-3.5 h-3.5 flex items-center justify-center text-accent-500" />
                    <strong className="text-accent-600">{links.filter((l) => l.status === "Ativo").length}</strong> ativos
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line w-3.5 h-3.5 flex items-center justify-center text-warning-500" />
                    <strong className="text-warning-600">{links.filter((l) => l.status === "Pendente" || l.status === "Em revisão").length}</strong> pendentes
                  </span>
                </div>
                <button
                  onClick={() => setExpandedProject(isExpanded ? null : projectName)}
                  className="px-3 py-1.5 text-xs font-medium text-primary-700 bg-primary-50 rounded-lg hover:bg-primary-100 transition-colors whitespace-nowrap"
                >
                  <i className={`${isExpanded ? "ri-arrow-up-s-line" : "ri-arrow-down-s-line"} w-3.5 h-3.5 inline-flex items-center justify-center mr-1`} />
                  {isExpanded ? "Recolher" : "Abrir vínculos"}
                </button>
              </div>

              {isExpanded && (
                <div className="border-t border-background-200 overflow-x-auto">
                  <table className="w-full text-sm">
                    <thead>
                      <tr className="border-b border-background-100 bg-background-50/30">
                        <th className="text-left px-4 py-2 text-xs font-semibold text-foreground-500 uppercase tracking-wider">Parte</th>
                        <th className="text-left px-4 py-2 text-xs font-semibold text-foreground-500 uppercase tracking-wider">Papel</th>
                        <th className="text-left px-4 py-2 text-xs font-semibold text-foreground-500 uppercase tracking-wider hidden md:table-cell">Documento</th>
                        <th className="text-left px-4 py-2 text-xs font-semibold text-foreground-500 uppercase tracking-wider">Início</th>
                        <th className="text-left px-4 py-2 text-xs font-semibold text-foreground-500 uppercase tracking-wider">Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {links.map((link) => (
                        <tr key={link.id} className="border-b border-background-50 hover:bg-background-50/30 transition-colors">
                          <td className="px-4 py-2.5 text-sm font-medium text-foreground-900">{link.partyName}</td>
                          <td className="px-4 py-2.5"><PartyRoleBadge role={link.role} /></td>
                          <td className="px-4 py-2.5 text-xs text-foreground-500 hidden md:table-cell">{link.sourceDocumentName}</td>
                          <td className="px-4 py-2.5 text-xs text-foreground-500">{link.startDate}</td>
                          <td className="px-4 py-2.5">
                            <span className={`inline-block px-2 py-0.5 rounded-full text-xs font-medium whitespace-nowrap ${linkStatusColors[link.status] || "bg-background-100 text-foreground-500"}`}>
                              {link.status}
                            </span>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}